import * as React from 'react';
import { Typography } from '@mui/material';
import { CourseCards } from '../../types/blocks/course-cards';
import { CourseType } from '@/shared/types';
import { CourseCard } from '../common/catalog-course-card';
import { SkilllevelsType } from '../../types/levels';
import { generateCourseColorScheme } from '../../utils/colors';

interface SectionPricesCourseCardsProps {
  element: CourseCards;
}

const capitalized = (word: CourseType): CourseType =>
  (word.charAt(0).toUpperCase() + word.slice(1)) as CourseType;

export const SectionPricesCourseCards: React.FC<SectionPricesCourseCardsProps> = ({ element }) => (
  <div className="max-w-[1264px] mx-auto px-4 md:px-8 lg:px-10 pt-8 pb-16 md:pt-16">
    <Typography variant="h1" component="h1" className="text-center mb-8">
      {element.title}
    </Typography>
    <div className="max-w-[330px] relative justify-center mx-auto">
      {element.courseCards?.length > 0 &&
        element.courseCards.map((el, i) => {
          const classNames = [
            'max-w-[330px] absolute left-[-20px] md:left-[-100px] lg:left-[-200px] top-0 -z-10 rotate-[-6deg] scale-90',
            'max-w-[330px] z-20',
            'max-w-[330px] absolute right-[-20px] md:right-[-100px] lg:right-[-200px] top-0 -z-10 rotate-[6deg] scale-90',
          ];
          return (
            <div key={i} className={classNames[i]}>
              <CourseCard
                description=""
                duration={0}
                highlighted={false}
                colorScheme={generateCourseColorScheme(false, el.courseType || 'masterclass')}
                title={el.title || ''}
                isCourseStarted={false}
                imageSrc={el.imageSrc || ''}
                videoCount={el.videoCount || 0}
                coursePercentage={el.coursePercentage || 0}
                {...el}
                genres={el.genres || []}
                courseType={el.courseType || 'masterclass'}
                level={
                  (el.level?.toLowerCase() as SkilllevelsType) || ('da zero' as SkilllevelsType)
                }
                isLocked={false}
                isSlider={false}
              />
            </div>
          );
        })}
    </div>
  </div>
);
